module.exports = __webpack_public_path__ + "static/img/assistant.395d3b9d.png";